import React, { useEffect, useMemo, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { Button, Col, Form, FormGroup, Spinner } from 'reactstrap';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, RSelect } from '../../../../components/Component';
import Content from '../../../../layout/content/Content';
import Head from '../../../../layout/head/Head';

import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from 'react-redux';
import { getAllCities } from '../../../../redux/admin/cities/actions';
import * as yup from "yup";
import { string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import subDays from "date-fns/subDays";
import { WEBSITE_API_URL } from '../../../../config';
import moment from "moment";
import { ColorRing } from 'react-loader-spinner';


const DateWiseOrders = () => {

    // get data from redux state
    const getSelectors = (state) => ({

        cities: state.cities.cities,
        form_loading: state.common.form_loading,

    });

    const { form_loading, cities } = useSelector(getSelectors);
    const dispatch = useDispatch();

    const [startDate, setStartDate] = useState(subDays(new Date(), 30));
    const [endDate, setEndDate] = useState(new Date());
    const [loading, setLoading] = useState(true);
    const [noDate, setNoDate] = useState(false);



    // form validation schema
    const exportSchema = yup.object({

        status: string().required(),
        city_id: string().required(),

    });

    // schema to edit form data
    const defaultValues = useMemo(
        () => ({
            status: "",
            city_id: "",
        }),
        []
    );

    const methods = useForm({
        resolver: yupResolver(exportSchema),
        defaultValues: defaultValues,
    });

    const {
        register,
        handleSubmit,
        setError,
        watch,
        control,
        formState: { errors },
        unregister,
        reset,
    } = methods;

    // get all cities  onload
    useEffect(() => {
        dispatch(getAllCities()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false);
            }
        })
    }, [])

    const onFormSubmit = (submitData) => {

        const token = localStorage.getItem('accessToken');
        const city_id = submitData?.city_id;
        const status = submitData?.status;
        const formatedStart = moment(startDate).format('DD-MM-yyyy');
        const formatedEnd = moment(endDate).format('DD-MM-yyyy');

        if (startDate && endDate) {
            window.location = WEBSITE_API_URL + "/export-sales-order-report?token=" + token + "&start_date=" + formatedStart + "&end_date=" + formatedEnd + "&city=" + city_id + "&status=" + status + "&type=SALES";
        } else {
            setNoDate(true)
        }
    }

    const handleDatePicker = (dates) => {
        setNoDate(false)
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    }

    // const all = { value: "ALL", label: "ALL" };
    const all_cities = cities?.map((city) => (
        { value: city.id, label: city.name }

    ));
    // all_cities.unshift(all);

    const status = [
        { value: "ALL", label: "ALL" },
        { value: "COMPLETED", label: "COMPLETED" },
        { value: "CANCELLED", label: "CANCELLED" },
    ];

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Date Wise Orders"></Head>

                    {/* content */}
                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Data wise Sales
                                    </BlockTitle>

                                </BlockHeadContent>

                            </BlockBetween>
                        </BlockHead>

                        <Block>
                            <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Choose Date Range</label>
                                        <div className="form-control-wrap">
                                            <DatePicker
                                                selected={startDate}
                                                onChange={handleDatePicker}
                                                startDate={startDate}
                                                endDate={endDate}
                                                selectsRange
                                                dateFormat="dd-MM-yyyy"
                                                className="form-control date-picker"
                                                required
                                            />
                                            {noDate && (
                                                <span className="invalid text-danger text-italic">Please Select Date Range </span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Choose City </label>
                                        <div className="form-control-wrap">
                                            <Controller
                                                name="city_id"
                                                control={control}
                                                render={({ onChange, value, ref }) => (
                                                    <RSelect
                                                        options={all_cities}
                                                        onChange={(val) => onChange(val.value)}
                                                        defaultValue={all_cities.find((c) => c.value === value)}
                                                    />
                                                )}
                                                ref={register({ required: "This field is required" })}
                                            />
                                            {errors.city_id && (
                                                <span className="invalid text-danger text-italic">Please choose a City </span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Choose Status </label>
                                        <div className="form-control-wrap">
                                            <Controller
                                                name="status"
                                                control={control}
                                                render={({ onChange, value, ref }) => (
                                                    <RSelect
                                                        options={status}
                                                        onChange={(val) => onChange(val.value)}
                                                        defaultValue={status.find((c) => c.value === value)}
                                                    />
                                                )}
                                                ref={register({ required: "This field is required" })}
                                            />
                                            {errors.status && (
                                                <span className="invalid text-danger text-italic">Please choose a Status </span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>


                                <Col md="12">
                                    <ul className="align-center justify-content-end flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button type="submit" color="primary" size="lg" className="btn-block">
                                                <Icon name="download-cloud " className="px-2"></Icon>
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" /> Export
                                                    </>
                                                ) : (
                                                    <React.Fragment>Export</React.Fragment>
                                                )}
                                            </Button>
                                        </li>

                                    </ul>
                                </Col>
                            </Form>
                        </Block>
                    </Content>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default DateWiseOrders
